import { render, staticRenderFns } from "./BenefitsControls.vue?vue&type=template&id=1caf61a4&"
import script from "./BenefitsControls.vue?vue&type=script&lang=js&"
export * from "./BenefitsControls.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsControls.vue?vue&type=style&index=0&id=1caf61a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports